import React from 'react'
import { Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

export const FormMicUnits = (props) => {

    const {
        handleInputChange, unit, abbreviation,
    } = props;

    return (
        <Form className="pt-3" role="form" >
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre de la unidad de medida <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="unit"
                            value={unit}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                        <Label className='label-admision'>Abreviación <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="abbreviation"
                            value={abbreviation}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                    </FormGroup>
                </Col>
            </Row>

        </Form>
    )
}
